import { useEffect } from 'react';

const siteUrl = 'https://taxobey.lk';
const defaultMetadata = {
  title: 'TaxObey',
  description: 'TaxObey offers tax compliance, accounting, and advisory services for individuals and businesses.',
  path: '/',
};

function upsertMeta(selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
}

function upsertLink(selector, attributes) {
  let element = document.head.querySelector(selector);

  if (!element) {
    element = document.createElement('link');
    document.head.appendChild(element);
  }

  Object.entries(attributes).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
}

export default function usePageTitle(metadata) {
  useEffect(() => {
    const nextMetadata = typeof metadata === 'string'
      ? { ...defaultMetadata, title: metadata }
      : { ...defaultMetadata, ...(metadata || {}) };
    const normalizedPath = nextMetadata.path === '/' ? '/' : nextMetadata.path.replace(/\/$/, '');
    const canonicalUrl = `${siteUrl}${normalizedPath}`;

    document.title = nextMetadata.title;

    upsertMeta('meta[name="description"]', {
      name: 'description',
      content: nextMetadata.description,
    });

    upsertMeta('meta[property="og:title"]', {
      property: 'og:title',
      content: nextMetadata.title,
    });

    upsertMeta('meta[property="og:description"]', {
      property: 'og:description',
      content: nextMetadata.description,
    });

    upsertMeta('meta[property="og:url"]', {
      property: 'og:url',
      content: canonicalUrl,
    });

    upsertMeta('meta[name="twitter:title"]', {
      name: 'twitter:title',
      content: nextMetadata.title,
    });

    upsertMeta('meta[name="twitter:description"]', {
      name: 'twitter:description',
      content: nextMetadata.description,
    });

    upsertLink('link[rel="canonical"]', {
      rel: 'canonical',
      href: canonicalUrl,
    });
  }, [metadata]);
}